import { useEffect, useState } from 'react'

// False on the server and in the first client render, so markup that depends on
// browser-only values (screen size, current time) matches the server HTML
export const useIsHydrated = (): boolean => {
  const [isHydrated, setIsHydrated] = useState<boolean>(false)
  useEffect(() => {
    setIsHydrated(true)
  }, [])
  return isHydrated
}
